<template>
    <div>
        <SOFilterBase
            v-if="isFilterOpen"
            :needVerify="filterItem.periode.filterBy == 'periode'"
            ref="filterBase"
            @verify="cekPeriode()"
            @back="toggleFilter(false)"
            @do-filter="doFilter"
            @reset-filter="resetFilter"
        >
            <template v-slot:filters>
                <div>
                    <SOFilterOneOutlet :id="`filter-one-outlet`"/>
                    <SOFilterPeriode
                        :id="`filter-periode`"
                        :title="`Periode`"
                        :periode-transaksi="false"
                        :option-data="periode.data"
                        v-model="periode.selected"
                        :filter-global-key="periode.filterGlobalKey"
                        :keterangan="periode.keterangan"
                    />
                    <SOFilterKonsumen :id="'filter-konsumen'" title="Konsumen" />
                    <SOFilterKaryawan
                        use-all-karyawan
                        :id="'filter-karyawan'"
                        :title="`Dibuat oleh`"
                        :label="`Nama Karyawan`"
                    />
                    <SOFilterJenisTransaksi
                        ref="filterJenisTransaksi"
                        :id="'filter-jenis-transaksi'"
                        :data-options="getFilterOptions.jenisTransaksi"
                    />
                    <SOFilterStatusTransaksi
                        ref="filterStatusTransaksi"
                        :id="'filter-status-transaksi'"
                        :data-options="getFilterOptions.statusTransaksi"
                    />
                    <SOFilterStatusKonfirmasi
                        ref="filterStatusBayar"
                        :id="'filter-status-bayar'"
                        :title="`Status Bayar`"
                        :data-options="getFilterOptions.statusBayarAdd"
                    />
                </div>
            </template>
        </SOFilterBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";
import filterOptions from "../static/filterOptions";

import SOFilterBase from "@/so-components/global/filter/base/SOFilterBase.vue";

import SOFilterPeriode from "@/so-components/global/filter/type/SOFilterPeriode";
import SOFilterJenisTransaksi from "@/so-components/global/filter/type/SOFilterJenisTransaksi";
import SOFilterStatusTransaksi from "@/so-components/global/filter/type/SOFilterStatusTransaksi";
import SOFilterStatusKonfirmasi from "@/so-components/global/filter/type/SOFilterStatusKonfirmasi";
import SOFilterOutlet from "@/so-components/global/filter/type/SOFilterOutlet";
import SOFilterKaryawan from "@/so-components/global/filter/type/SOFilterKaryawan";
import SOFilterOneOutlet from "@/so-components/global/filter/type/SOFilterOneOutlet";
import SOFilterKonsumen from "@/so-components/global/filter/type/SOFilterKonsumen";

export default {
    name: "FilterInvoiceAdd",
    props: {
        loadTransaksi: {
            type: Function,
            required: true,
        },
    },
    components: {
        SOFilterBase,
        SOFilterPeriode,
        SOFilterJenisTransaksi,
        SOFilterStatusTransaksi,
        SOFilterStatusKonfirmasi,
        SOFilterOutlet,
        SOFilterKaryawan,
        SOFilterOneOutlet,
        SOFilterKonsumen,
    },
    data() {
        return {
            periode: {
                data: [],
                selected: "",
                filterGlobalKey: "",
                keterangan: "",
            },
            verifyValue: false
        };
    },
    computed: {
        ...mapGetters(moduleName, {
            isFilter: "isFilter",
        }),
        ...mapGetters("filterGlobalModule", {
            filterItem: "getFilterItem",
        }),
        isFilterOpen() {
            return this.isFilter;
        },
        getFilterOptions() {
            return filterOptions;
        },
    },
    methods: {
        ...mapActions({
            setFilter: `${moduleName}/setFilter`,
        }),
        toggleFilter(val) {
            this.setFilter(val);
        },
        cekPeriode() {
            const periode = this.filterItem.periode
            if (periode.startDate && periode.endDate) {
                const end = this.$moment(periode.startDate, "YYYY-MM-DD");
                const start = this.$moment(periode.endDate, "YYYY-MM-DD");
                const diffDay = this.$moment.duration(start.diff(end)).asDays();
                if (diffDay > 365) {
                    this.$toast.error('Tanggal periode tidak boleh lebih dari 1 tahun')
                }
                this.verifyValue = diffDay < 365
                this.$refs.filterBase.setVerify(this.verifyValue)
            }
            else {
                this.$toast.error('Tanggal awal dan akhir periode harus diisi')
                this.verifyValue = false
                this.$refs.filterBase.setVerify(this.verifyValue)
            }
        },
        async doFilter() {
            await this.toggleFilter(false);
            this.loadTransaksi();
        },
        async resetFilter() {
            await this.$store.commit("filterGlobalModule/resetFilterItem");
        },
    },
};
</script>
